export default
{
    guardaSolicitud:"/patologia/guardaSolicitud",
    imprimeSolicitud:"/patologia/imprimeBitacora",
    listLaboratorios:"/patologia/listLaboratorios",
    listSolicitud:"/patologia/listSolicitud",
}